import type { SlugNode } from '@/lib/slug-rewrites';

export const routeName = 'partner-ngos';
export const slugs: Record<string, string> = {
	es: 'ong-colaboradoras',
	en: 'partner-ngos',
	ca: 'ong-collaboradores',
	fr: 'ong-partenaires',
	it: 'ong-partner',
};
/**
 * The one segment below this page is an NGO's id — the partner whose campaigns sheet is open, which
 * the directory puts in the URL so it can be shared.
 *
 * Declared EMPTY on purpose, and that is not the same as declaring nothing. The rewrite only looks
 * past the first segment for a route that owns what is below it (`hasChildSegments`), so without this
 * export `/ong-colaboradoras/<id>` would never be rewritten to the internal route name and would 404.
 * With it the depth gate opens, and because the tree names no segment, `walkSegments` leaves the id
 * untouched in both directions — which is exactly right for an id: it is data, not a word that has a
 * translation per locale.
 */
export const children: Record<string, SlugNode> = {};

export const sitemap = { changefreq: 'monthly', priority: '0.8', lastmod: '2026-08-24' };
